var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16.3C9.37964 16.3 11.2857 14.4485 11.2857 12.192C11.2857 10.3171 10.1507 8.17195 8.9125 6.41635C8.32372 5.58533 7.6851 4.78931 7 4.0325C6.92595 4.11417 6.84595 4.20388 6.76 4.30165C6.1652 4.97744 5.60693 5.68331 5.0875 6.41635C3.84929 8.17195 2.71429 10.3171 2.71429 12.192C2.71429 14.4481 4.62036 16.3 7 16.3ZM6.51429 3.5145C5.25786 4.89315 2 8.796 2 12.192C2 14.8475 4.23857 17 7 17C9.76143 17 12 14.8475 12 12.192C12 8.796 8.74214 4.89315 7.48571 3.5145C7.18571 3.1855 7 3 7 3C7 3 6.81429 3.1855 6.51429 3.5145Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/Blood.62dddf1d2a096a1729c9d886937faeec.svg";
export { ForwardRef as ReactComponent };